import { SxProps, Theme } from '@mui/material/styles';

export const stepFourStyles = {
  container: {
    minHeight: '100vh',
    py: 0,
    px: 0,
    overflow: 'hidden', // Previne scroll-ul horizontal
    width: '100%'
  } as SxProps<Theme>,

  paper: (background: string) => ({
    backgroundImage: `url(${background})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    borderRadius: 0,
    overflow: 'hidden',
    boxShadow: 'none',
    width: '100%',
    minHeight: '100vh',
    maxWidth: '100%'
  } as SxProps<Theme>),

  header: {
    textAlign: 'center',
    py: 3,
    color: 'white',
    position: 'relative'
  } as SxProps<Theme>,

  logo: {
    maxHeight: { xs: '60px', sm: '80px' },
    maxWidth: '100%',
    height: 'auto',
    filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.7))'
  } as SxProps<Theme>,

  content: {
    p: 4,
    maxWidth: '600px',
    mx: 'auto'
  } as SxProps<Theme>,

 mainTitle: (theme: Theme) => ({
    textAlign: 'center',
    fontWeight: 'bold',
    color: theme.colors.dark_chocolate,
    fontSize: { xs: '2.5rem', sm: '3.5rem' },
    fontFamily: theme.fonts.poplar
  }) as SxProps<Theme>,

  subtitle: (theme: Theme) => ({
    textAlign: 'center',
    fontWeight: 'bold',
    color: theme.colors.dark_chocolate,
    fontSize: { xs: '2.5rem', sm: '3.5rem' },
    fontFamily: theme.fonts.poplar,
    mb: 2
  }) as SxProps<Theme>,

  prizeSection: {
    background: '#860d0d',
    color: 'white',
    p: 2,
    borderRadius: 3,
    mb: 4,
    textAlign: 'center',
    boxShadow: '0 8px 16px rgba(0,0,0,0.3)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    minHeight: '120px'
  } as SxProps<Theme>,

  prizeTitle: {
    fontWeight: 'bold',
    color: '#E3CB9F',
    fontSize: { xs: '1.2rem', sm: '1.5rem' },
    mb: 2
  } as SxProps<Theme>,

  prizeContent: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100%',
    gap: 3
  } as SxProps<Theme>,

  prizeLeftSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1
  } as SxProps<Theme>,

  prizeCircle: {
    backgroundColor: '#E3CB9F',
    borderRadius: '50%',
    width: { xs: '60px', sm: '70px' },
    height: { xs: '60px', sm: '70px' },
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.2
  } as SxProps<Theme>,

  prizeCircleNumber: {
    fontWeight: 'bold',
    color: '#40301E',
    fontSize: { xs: '1.5rem', sm: '1.8rem' },
    lineHeight: 1,
    mt: 0.5
  } as SxProps<Theme>,

  prizeCircleText: {
    fontWeight: 'bold',
    color: '#40301E',
    fontSize: { xs: '1.2rem', sm: '1.4rem' },
    lineHeight: 1,
    mt: 0.5
  } as SxProps<Theme>,

  prizeAmount: {
    fontWeight: 'bold',
    color: '#E3CB9F',
    fontSize: { xs: '0.8rem', sm: '1rem' },
    textAlign: 'center',
    lineHeight: 1.2
  } as SxProps<Theme>,

  prizeImageInSection: {
    maxHeight: { xs: '80px', sm: '100px' },
    height: 'auto',
    width: 'auto',
    filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))'
  } as SxProps<Theme>,

  voucherContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    mb: 4
  } as SxProps<Theme>,

  voucherCount: {
    fontWeight: 'bold',
    color: '#40301E',
    mt: 0.5
  } as SxProps<Theme>,

  voucherImage: {
    maxHeight: { xs: '80px', sm: '100px' },
    maxWidth: '200px',
    height: 'auto',
    width: 'auto',
    transform: 'rotate(-5deg)',
    filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))',
    mt: -3.5,
    ml: -2.5
  } as SxProps<Theme>,

  lineContainer: {
    display: 'flex',
    justifyContent: 'center',
    mb: 1
  } as SxProps<Theme>,

  lineImage: {
    maxWidth: '100%',
    height: 'auto',
    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
  } as SxProps<Theme>,

  instructionsContainer: {
    p: 3
  } as SxProps<Theme>,

  instructionsText: {
    textAlign: 'center',
    color: '#40301E',
    fontWeight: 'bold'
  } as SxProps<Theme>,

   instructionsText2: (theme: Theme) => ({
    textAlign: 'center',
    color: '#40301E',
    fontWeight: 'bold',
    fontFamily: theme.fonts.poplar,
    fontSize: { xs: '1.8rem', sm: '2.2rem' }, 
   }) as SxProps<Theme>,

  moreReceiptsContainer: {
    p: 3
  } as SxProps<Theme>,

  moreReceiptsText: {
    textAlign: 'center',
    color: '#40301E',
    fontWeight: 'bold'
  } as SxProps<Theme>,

  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    mb: 4
  } as SxProps<Theme>,

  uploadButton: {
    backgroundColor: '#800000',
    color: '#E3CB9F',
    py: 2,
    fontSize: '1.2rem',
    fontWeight: 'bold',
    borderRadius: 3,
    boxShadow: '0 6px 12px rgba(0,0,0,0.3)',
    minWidth: '300px',
    '&:hover': {
      backgroundColor: '#860d0d',
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 16px rgba(0,0,0,0.4)'
    },
    '&:disabled': {
      backgroundColor: '#800000',
      color: '#E3CB9F',
      opacity: 1
    },
    transition: 'all 0.3s ease'
  } as SxProps<Theme>,

  footer: {
    mt: 4,
    textAlign: 'center'
  } as SxProps<Theme>,

  footerImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  } as SxProps<Theme>,

  footerImage: {
    maxHeight: { xs: '40px', sm: '50px' },
    maxWidth: '200px',
    height: 'auto',
    width: 'auto',
    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
  } as SxProps<Theme>
};